import { ReactNode } from 'react'

export default function Layout({ children }: { children: ReactNode }) {
  return <div className='font-base geometric-precision text-gray-dark text-base antialiased'>{children}</div>
}
